'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPreferredLocale = exports.setPreferredLocale = exports.LANG_CODE_TO_FULL_NAME = undefined;

var _LANGUAGE_TO_LOCALE, _LANG_CODE_TO_FULL_NA;

exports.getLocaleFromReferrer = getLocaleFromReferrer;
exports.overrideBrowserLocale = overrideBrowserLocale;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _Url = require('urlinator/Url');

var _Url2 = _interopRequireDefault(_Url);

var _isEmpty = require('hs-lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _without = require('hs-lodash/without');

var _without2 = _interopRequireDefault(_without);

var _keyMirror = require('react-utils/keyMirror');

var _keyMirror2 = _interopRequireDefault(_keyMirror);

var _LocaleDAO = require('../data/LocaleDAO');

var LocaleDAO = _interopRequireWildcard(_LocaleDAO);

var _UserInfoActionTypes = require('../actionTypes/UserInfoActionTypes');

var _actionWithPayload = require('../../core/utils/actionWithPayload');

var _actionWithPayload2 = _interopRequireDefault(_actionWithPayload);

var _AnalyticsActions = require('../actions/AnalyticsActions');

var _UsageTrackerContainer = require('../tracking/UsageTrackerContainer');

var _UsageTrackerContainer2 = _interopRequireDefault(_UsageTrackerContainer);

var _QueryParamsContainer = require('../globals/QueryParamsContainer');

var _QueryParamsContainer2 = _interopRequireDefault(_QueryParamsContainer);

var _Logger = require('../lib/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LOG = _Logger2.default.getLogger('LocaleActions');

var LANGUAGES = (0, _keyMirror2.default)({
  es: null,
  fr: null,
  br: null,
  de: null,
  jp: null,
  ja: null,
  en: null
});

var LANGUAGE_TO_LOCALE = (_LANGUAGE_TO_LOCALE = {}, _defineProperty(_LANGUAGE_TO_LOCALE, LANGUAGES.es, 'es'), _defineProperty(_LANGUAGE_TO_LOCALE, LANGUAGES.fr, 'fr'), _defineProperty(_LANGUAGE_TO_LOCALE, LANGUAGES.br, 'pt-br'), _defineProperty(_LANGUAGE_TO_LOCALE, LANGUAGES.de, 'de'), _defineProperty(_LANGUAGE_TO_LOCALE, LANGUAGES.jp, 'ja'), _defineProperty(_LANGUAGE_TO_LOCALE, LANGUAGES.ja, 'ja'), _defineProperty(_LANGUAGE_TO_LOCALE, LANGUAGES.en, 'en'), _LANGUAGE_TO_LOCALE);

var LANG_CODE_TO_FULL_NAME = exports.LANG_CODE_TO_FULL_NAME = (_LANG_CODE_TO_FULL_NA = {}, _defineProperty(_LANG_CODE_TO_FULL_NA, LANGUAGES.es, 'Spanish'), _defineProperty(_LANG_CODE_TO_FULL_NA, LANGUAGES.fr, 'French'), _defineProperty(_LANG_CODE_TO_FULL_NA, LANGUAGES.br, 'Portuguese'), _defineProperty(_LANG_CODE_TO_FULL_NA, LANGUAGES.de, 'German'), _defineProperty(_LANG_CODE_TO_FULL_NA, LANGUAGES.jp, 'Japanese'), _defineProperty(_LANG_CODE_TO_FULL_NA, LANGUAGES.ja, 'Japanese'), _defineProperty(_LANG_CODE_TO_FULL_NA, LANGUAGES.en, 'English'), _LANG_CODE_TO_FULL_NA);

function matchesSupportedLanguage(maybeLanguage) {
  return LANGUAGES.hasOwnProperty(maybeLanguage);
}

function getLanguageFromReferrer(referrerUrl) {
  if ((0, _isEmpty2.default)(referrerUrl)) {
    return null;
  }
  var url = new _Url2.default(referrerUrl);
  if (url.hostname.indexOf('hubspot') === -1) {
    return null;
  }

  var maybeTld = url.hostname.slice(url.hostname.lastIndexOf('.') + 1, url.hostname.length);
  var maybeSubdomain = url.hostname.slice(0, url.hostname.indexOf('.'));
  var locale = '';
  if (matchesSupportedLanguage(maybeTld)) {
    locale = maybeTld;
  } else if (matchesSupportedLanguage(maybeSubdomain)) {
    locale = maybeSubdomain;
  } else if (maybeTld.indexOf('com') === 0) {
    // last chance, if is not taken from 3rd level domain or top level domain and it's .com, set 'en'
    locale = 'en';
  }

  return locale;
}

function getLocaleFromReferrer(referrerUrl) {
  var languageFromReferrer = getLanguageFromReferrer(referrerUrl);

  if (languageFromReferrer) {
    return LANGUAGE_TO_LOCALE[languageFromReferrer];
  }

  return null;
}

// choose when browser locale should be overridden
function overrideBrowserLocale(localeFromReferrer, browserLanguages) {
  // override locale only for referrer != 'en' (br,jp, etc.) and that locale not being top of the preferred languages
  if (localeFromReferrer) {
    return localeFromReferrer.indexOf('en') === -1 && browserLanguages.length > 0 && browserLanguages[0].toLowerCase().indexOf(localeFromReferrer) === -1;
  }
  return false;
}

// Set the locale in the portal's settings for all users on this portal
var setPreferredLocale = exports.setPreferredLocale = function setPreferredLocale() {
  return function () {
    //priority
    //1. explicit language parameter set `lang=<something>`
    //2. locale from referrer (from source landing page)
    //3. locale from browser
    var browserLanguages = navigator.languages || [];
    var localeFromReferrer = getLocaleFromReferrer(window.document.referrer);
    var localeFromExplicitParam = _QueryParamsContainer2.default.get('lang');
    var localeOverride = localeFromExplicitParam || localeFromReferrer;
    if (overrideBrowserLocale(localeOverride, browserLanguages)) {
      var cleanedBrowserLanguages = browserLanguages;
      if (browserLanguages.indexOf(localeOverride) !== -1) {
        // if the localeOverride is already in the browserLanguages, but not first priority,
        // then we need to clean it out of the browserLanguages before concatenating the
        // localeOverride to the top of the list.
        cleanedBrowserLanguages = (0, _without2.default)(browserLanguages, localeOverride);
      }
      return LocaleDAO.setLocale([localeOverride].concat(cleanedBrowserLanguages));
    }
    return LocaleDAO.setLocale();
  };
};

// Pings a service that pulls the browser's preferred language.
// Once fetched, I18n is updated, and the new language is
// (hopefully) hot swapped into the user interface.
var getPreferredLocale = exports.getPreferredLocale = function getPreferredLocale() {
  return function (dispatch) {
    var langFromQueryString = _QueryParamsContainer2.default.get('lang');
    // IE11 doesnt have navigator.languages
    var languages = navigator.languages ? [].concat(_toConsumableArray(navigator.languages)) : [];
    var maybeLocaleFromReferrer = void 0;

    if (langFromQueryString) {
      languages.unshift(langFromQueryString);
    }

    try {
      maybeLocaleFromReferrer = getLocaleFromReferrer(window.document.referrer);

      (0, _AnalyticsActions.trackEvent)('compareLanguage', {
        action: 'compare languages',
        referrerLanguage: maybeLocaleFromReferrer || 'none',
        browserLanguage: languages[0] || 'none'
      });
    } catch (e) {
      LOG.warn('Failed getting locale from referrer');
    }

    if (overrideBrowserLocale(maybeLocaleFromReferrer, languages)) {
      languages = [maybeLocaleFromReferrer].concat(languages);
    }

    dispatch((0, _actionWithPayload2.default)(_UserInfoActionTypes.STORE_USERDATA, { languages: languages }));

    if (languages && languages.length > 0) {
      // Match against small name, removes -US suffix
      var lang = languages[0].toLowerCase().replace('-us', '');
      if (_I18n2.default.lang !== lang) {
        _I18n2.default.setPublicLangPreference(lang);
        _I18n2.default.changeLocale(lang);

        if (maybeLocaleFromReferrer) {
          (0, _AnalyticsActions.trackEvent)('setLanguage', {
            action: 'set language',
            language: lang,
            languageOrigin: 'referrer'
          });
        } else {
          (0, _AnalyticsActions.trackEvent)('setLanguage', {
            action: 'set language',
            language: lang,
            languageOrigin: 'browser'
          });
        }
      }
      // update tracker with found lang property
      _UsageTrackerContainer2.default.setProperties({ lang: lang });
    } else {
      (0, _AnalyticsActions.trackEvent)('setLanguage', {
        action: 'set language',
        language: 'none-detected',
        languageOrigin: 'none'
      });
    }
    return _q2.default.Promise.resolve();
  };
};